// extracted by mini-css-extract-plugin
export var buttons = "_9q-0";
export var buttonsActive = "_9q-h";
export var cancelConfirm = "_9q-1";
export var closeButton = "_9q-2";
export var column = "_9q-3";
export var container = "_9q-4";
export var detailHeader = "_9q-6";
export var detailTitle = "_9q-7";
export var detailsContent = "_9q-5";
export var header = "_9q-8";
export var headerWithClose = "_9q-9";
export var icon = "_9q-a";
export var infoIcon = "_9q-c";
export var informationContainer = "_9q-b";
export var sideDrawer = "_9q-d";
export var sideDrawerOpen = "_9q-e";
export var stickyFooter = "_9q-f";
export var typeOption = "_9q-g";